import { useCallback } from 'react';
import { logEvent } from '@eventbrite/legacy-infra.statsig';
import { GACodes, STATSIG_EVENT_NAMES } from '@/components/_shared/constants';
import { trackAnalyticsEvent } from '@eventbrite/legacy-infra.site-analytics';

export const useTrackCheckoutButtonClick = () => {
  const trackCheckoutButtonClick = useCallback((trackingLabel?: string) => {
    logEvent(STATSIG_EVENT_NAMES.LISTING_CONVERSION_BAR_CTA_CLICK);
    trackAnalyticsEvent({
      action: GACodes.GA_ACTION_CHECKOUT,
      category: GACodes.GA_CATEGORY_LISTING,
      label: trackingLabel ?? 'Get Tickets',
    });
  }, []);

  return trackCheckoutButtonClick;
};
